import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component
import { context } from 'bookingbug-core-js';
import { BasketService, DataStoreService } from '././services';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';

if (!environment.production) {
  console.warn('App loaded in staging mode!');
  console.table(environment);
}

// BB Context storage
context.apiUrl = environment.environmentURL;
context.apiVersion = 'v5';
context.appId = 'f6b16c23';
context.appKey = 'f0bc4f65f4fbfe7b4b3b7264b655f5eb';

// This global variable controls the language for the dynamically added content
// Such as BB service names, descriptions.
// 0 = english  / 1 = irish
context.blLanguage = 0;

// Custom local storage

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  loadIssue: boolean;

  constructor(private bnIdle: BnNgIdleService, private router: Router, private DataStore: DataStoreService, private ngZone: NgZone, private _cookieService: CookieService, private basketservice: BasketService) {
    this.bnIdle.startWatching(900).subscribe((res) => {
      if (res) {
        if (this.router.url !== '/payment') {
          this.DataStore.parentID = 37000;
          delete this.DataStore.clientDetails;
          delete this.DataStore.applicationDetails;
          delete this.DataStore.applicantArray;
          delete this.DataStore.applicantArrayCopy;
          delete this.DataStore.bookingQuestion;
          delete this.DataStore.dynamicForm;
          this.DataStore.basketItems.length = 0;

          console.log(this);
          this.ngZone.run(() => this.router.navigate(['/sessionExpired']));
        }
      }
    });

    this.DataStore.notify.subscribe((result) => {
      this.loadIssue = result;
      this.scrollToTop();
    })
  }

  onActivate(event) {
    this.scrollToTop();
  }

  scrollToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }
}
